import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/cn";

const heading = cva("font-bold tracking-tight text-text", {
  variants: {
    size: {
      lg: "text-3xl",
      base: "text-xl",
      sm: "text-lg",
      xs: "text-base",
    },
  },
  defaultVariants: { size: "base" },
});

const LEVEL_DEFAULT_SIZE: Record<1 | 2 | 3 | 4, VariantProps<typeof heading>["size"]> = {
  1: "lg",
  2: "base",
  3: "sm",
  4: "xs",
};

type HeadingProps = VariantProps<typeof heading> &
  Omit<React.HTMLAttributes<HTMLHeadingElement>, "className"> & {
    level?: 1 | 2 | 3 | 4;
    as?: React.ElementType;
    className?: string;
  };

export function Heading({ level = 2, size, as, className = "", ...props }: HeadingProps) {
  const Component = as ?? (`h${level}` as React.ElementType);
  return <Component className={cn(heading({ size: size ?? LEVEL_DEFAULT_SIZE[level] }), className)} {...props} />;
}
